export default "__VITE_ASSET__CEtXRsAN__"